import { queryRoots, type QueryKey } from '@/shared/query';

export const pluginKeys = {
  all: (): QueryKey => [queryRoots.plugins],
  slackStatus: (): QueryKey => [queryRoots.plugins, 'slack', 'status'],
} as const;
